<template>
    <div>
        <div class="divide-y">
            <div
                v-for="(choice, index) in choices"
                :key="index"
                class="relative mb-4"
                :class="[index > 0 ? 'pt-2' : '']"
            >
                <div class="absolute right-0" :class="[index > 0 ? 'top-2' : 'top-0']">
                    <button @click="remove(index)" class="text-sm text-secondary">{{ __('Remover') }}</button>
                </div>

                <ProductAndTicketReasonItem :values="values" :value="choice" :index="index" />
            </div>
        </div>

        <alo-button tamanho="pequeno" @click.native="addProduct()">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                <path
                    fill-rule="evenodd"
                    d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                    clip-rule="evenodd"
                />
            </svg>
            <span>{{ __('Adicionar produto') }}</span>
        </alo-button>
    </div>
</template>

<script>
import * as Form from '@App/Utils/Form'
import ProductAndTicketReasonItem from './ProductsAndTicketReasons/Item.vue'

export default {
    components: { ProductAndTicketReasonItem },
    props: ['value', 'field', 'values'],
    data() {
        return {
            choices: this.values.products_and_ticket_reasons || [
                {
                    product_id: null,
                    product_ticket_reasons_ids: [],
                },
            ],
        }
    },
    watch: {
        choices: {
            deep: true,
            handler(value) {
                let productId = null
                if (value.length > 0) productId = value[0].product_id

                this.$emit('input', {
                    products_and_ticket_reasons: value,
                    [Form.name(this.field)]: productId,
                    _spread: true,
                })
            },
        },
    },
    methods: {
        addProduct() {
            this.choices.push({
                product_id: null,
                product_ticket_reasons_ids: [],
            })
        },

        remove(index) {
            this.choices.splice(index, 1)
        },
    },
}
</script>